import { createAction, props } from '@ngrx/store';
import {MitarbeiterItem} from '../../mitarbeiter.model';

export const editMitarbeiterStart = createAction('MITARBEITERVERWALTUNG::EDIT_MITARBEITER_START', props<{ item: MitarbeiterItem }>());
export const editMitarbeiterSucceeded = createAction('MITARBEITERVERWALTUNG::EDIT_MITARBEITER_SUCCEEDED', props<{ item: MitarbeiterItem }>());
export const editMitarbeiterFailed = createAction('MITARBEITERVERWALTUNG::EDIT_MITARBEITER_FAILED', props<{ error: Error }>());
